import fetch from 'utils/fetch';
import store from '../store';
export function getCharts() {
    return fetch({
        url: '/adt/enuser/index_1',
        method: 'post',
    });
}

export function getModuleCount() {
    return fetch({
        url: '../../static/json/count.json',
        method: 'get',
    });
}
export function getHotWord() {
    return fetch({
        url: '../../static/json/searchWord.json',
        method: 'get',
    });
}
export function getHotCompany() {
    return fetch({
        url: '../../static/json/company.json',
        method: 'get',
    });getHotCompany
}
export function getHotPark() {
    return fetch({
        url: '../../static/json/park.json',
        method: 'get',
    });
}
export function getHotInvest() {
    return fetch({
        url: '../../static/json/invest.json',
        method: 'get',
    });
}
export function getHotPolicy() {
    return fetch({
        url: '../../static/json/policy.json',
        method: 'get'
    });
}
export function getProductReport() {
    return fetch({
        url: '../../static/json/productReport.json',
        method: 'get',
    });
}
export function getSwiperImg() {
    return fetch({
        url: '../../static/json/swiper.json',
        method: 'get',
    });
}
export function getProductAndPark() {
    return fetch({
        url: '../../static/json/parkAndproductState.json',
        method: 'get',
    });
}

export function getSystemUnitCode() {
     return  fetch({
        url: '/system/unitCode',
        method: 'get'
    });
}


export function getCeiVlst() {
    return  fetch({
        url: '/manage/cei/vlst',
        method: 'post'
    });
}


export function ceiLoginOut() {
    return  fetch({
        url: '/sso/cei/loginOut',
        method: 'get'
    });
}


// WEBPACK FOOTER //
// ./src/api/home.js